import React, { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";
import { Logo } from "./Logo";
import { scrollToId } from "../hooks/useLenis";
import { FIRM } from "../lib/practiceAreas";

const NAV = [
  { id: "about", label: "About" },
  { id: "services", label: "Practice Areas" },
  { id: "walk-in", label: "Walk-In" },
  { id: "team", label: "Our Team" },
  { id: "contact", label: "Contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    scrollToId(id);
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0B0B0E]/75 backdrop-blur-xl border-b border-white/5 shadow-[0_1px_0_rgba(245,242,232,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <button
          data-testid="header-logo-btn"
          onClick={() => go("hero")}
          className="group"
          aria-label="Lawfields Solicitors home"
        >
          <Logo size={44} />
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="font-sans text-sm text-white/65 hover:text-[#E9C76A] transition-colors duration-300 tracking-wide relative after:absolute after:bottom-[-6px] after:left-0 after:h-px after:w-0 after:bg-[#E9C76A] hover:after:w-full after:transition-all after:duration-300"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${FIRM.phone.replace(/\s/g, "")}`}
            data-testid="header-phone"
            className="hidden md:inline font-sans text-sm text-white/80 hover:text-[#E9C76A] transition-colors"
          >
            {FIRM.phone}
          </a>
          <span
            className="hidden md:inline-block bg-white/15"
            style={{ width: 1, height: 22, marginLeft: 12, marginRight: 12 }}
            aria-hidden
          />
          <button
            data-testid="header-cta"
            onClick={() => go("contact")}
            className="hidden md:inline-flex btn-gold"
          >
            Free Consultation
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-[#F5F2E8]"
            onClick={() => setOpen(!open)}
            aria-label="menu"
          >
            {open ? <X size={26} /> : <List size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#0B0B0E]/95 backdrop-blur-xl border-t border-white/5 px-6 py-6 space-y-4"
        >
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`mobile-nav-${n.id}`}
              onClick={() => go(n.id)}
              className="block w-full text-left font-sans text-base text-white/75 hover:text-[#E9C76A]"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="mobile-cta"
            onClick={() => go("contact")}
            className="w-full btn-gold mt-2"
          >
            Free Consultation
          </button>
        </div>
      )}
    </header>
  );
};
